import { I2cIcon, I2cTooltip } from "@webcomponents/i2cwebcomponents/dist/react";

/**
 * Reusable tooltip icon component.
 *
 * @param {string} content - Tooltip text content (required).
 * @param {string} [color="#6B7080"] - Icon color.
 * @param {string} [placement="right-start"] - Tooltip placement.
 * @param {string} [name="cs-linear-info"] - Icon name.
 */
const TooltipIcon = ({
  content,
  color = "#6B7080",
  placement = "right-start",
  name = "cs-linear-info",
}) => {
  return (
    <I2cTooltip content={content} placement={placement}>
      <I2cIcon label="info" name={name} color={color}></I2cIcon>
    </I2cTooltip>
  );
};

export default TooltipIcon;
